export default __webpack_public_path__ + "static/media/talent-main-section-buy-project-Dev-IT.fc37068b.png";